import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { isEqual } from 'lodash';
import getExtendedSelectedOptionsFromFullFormat from 'components/consumer/PDP/state/helpers/getExtendedSelectedOptionsFromFullFormat';
import useSetPdpSelectedOptionsExtended from '../pdpSelectedOptionsExtended/usePdpSetSelectedOptionsExtended';

// This hook is used to set values for all options on PDP
const useSetPdpAllSelectedOptions = () => {
  const $ = _c(2);
  const setPdpSelectedOptionsExtended = useSetPdpSelectedOptionsExtended();
  let t0;
  if ($[0] !== setPdpSelectedOptionsExtended) {
    t0 = updatedPdpSelectedOptionsFull => {
      setPdpSelectedOptionsExtended(currentPdpSelectedOptionsExtended => {
        const updatedPdpSelectedOptionsExtended = getExtendedSelectedOptionsFromFullFormat(updatedPdpSelectedOptionsFull);
        if (isEqual(currentPdpSelectedOptionsExtended, updatedPdpSelectedOptionsExtended)) {
          return currentPdpSelectedOptionsExtended;
        }
        return updatedPdpSelectedOptionsExtended;
      });
    };
    $[0] = setPdpSelectedOptionsExtended;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setPdpAllSelectedOptions = t0;
  return setPdpAllSelectedOptions;
};
export default useSetPdpAllSelectedOptions;